import store from "@/store";
import axios from "axios";
import { Toast } from "vant";

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 15000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些处理
    const token = store.state.token
    token && (typeof token != 'boolean') && (config.headers.Authorization = token)
    return config;
  },
  (error) => {
    // 处理请求错误
    Toast.clear()
    return Promise.reject(error.response.data);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 在这里对响应数据进行处理
    return response.data;
  },
  (error) => {
    // 处理响应错误
    return Promise.reject(error);
  }
);

export default service;
